<section class="fly__setting" [class.block]="isVisibleFlightConfigurationSetting">
    <div class="wrap inner relative">
        <div class="tit-box">
            <a class="back-btn" (click)="toggleFlightConfigurationSettingVisible()"></a>
            <div class="main-txt">
                {{ "configuration.title" | translate }}
            </div>
            <div class="setting-box">
                <a (click)="toggleUnitSettingVisible()" class="setting-btn">
                    <i class="ic ic-setting"></i>
                    <span class="txt">
                        {{ "configuration.unitSetting" | translate }}
                    </span>
                </a>
            </div>

            <div class="sub-menu-box">
                <div class="cbox">
                    <label >
                        <input type="checkbox" (click)="changeContainsGust()" [checked]="isContainedGust">
                        <i></i>
                        <span class="txt">
                            {{ "configuration.containGust" | translate}}
                        </span>
                    </label>
                </div>
            </div>
        </div>
        <droneSpecifiation (getChangeDroneEvent)="changeDrone($event)" class="setting-drone-box"></droneSpecifiation>
        <flightConfig (getChangeFlightConfigEvent)="changeFlightConfigInfoEvent($event)" class="setting-data-box"></flightConfig>
    </div>
</section>
<unit [isVisibleUnitSetting]="isVisibleUnitSetting" (getToggleVisibleEvent)="toggleUnitSettingVisible()" (userUnitEvent)="changeUnitEvent($event)"></unit>
